export default {
      id: "layers-usage",
      viewBox: "0 0 234.46 247.78",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#layers",
      toString: function () {
        return this.url;
      }
    }